module.exports = `:root {
  --primitiveColorPrimary25: #0a0810;
  --primitiveColorPrimary50: #120f1a;
  --primitiveColorPrimary100: #1b192d;
  --primitiveColorPrimary150: #242242;
  --primitiveColorPrimary238: #343269;
  --primitiveColorPrimary300: #454074;
  --primitiveColorPrimary400: #5e5987;
  --primitiveColorPrimary500: #78729b;
  --primitiveColorPrimary650: #9f9ab8;
  --primitiveColorPrimary850: #d5d3e0;
  --primitiveColorPrimary900: #e3e1ea;
  --primitiveColorPrimary950: #f1f0f5;
  --primitiveColorPrimary975: #f8f8fa;
  --primitiveColorAccent820: #febf00;
  --primitiveColorAccent900: #ffe085;
  --primitiveColorAccent980: #fff8e2;
}
`;